// extracted by mini-css-extract-plugin
export var chevron = "_id-2";
export var chevronRotated = "_id-3";
export var header = "_id-1";
export var section = "_id-0";